import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin/dashboard");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center pt-24 pb-16">
      <div className="w-full max-w-md px-6">
        <div className="overline mb-6">Maklan Motors · Admin</div>
        <h1 className="font-display text-5xl mb-3">Sign in.</h1>
        <p className="text-white/60 mb-10">Access the submissions dashboard.</p>
        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label className="field-label">Email</label>
            <input required type="email" className="field" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email"/>
          </div>
          <div>
            <label className="field-label">Password</label>
            <input required type="password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password"/>
          </div>
          <button disabled={busy} className="btn-gold w-full" data-testid="admin-submit">
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
